module.exports = __webpack_public_path__ + "img/保存2.c1ab32bf.svg";